import React from "react";

function Button({
  children,
  type = "button",
  variant = "primary",
  className = "",
  disabled = false,
  onClick,
}) {
  const base =
    "w-full rounded-lg py-3 px-6 font-josefin text-base transition duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed";

  const variants = {
    primary:
      "bg-secondaryDark text-white hover:bg-primaryBack border border-transparent",
    google:
      "bg-backLight text-primaryText border border-primaryText hover:bg-backSection",
  };

  return (
    <button
      type={type}
      className={`${base} ${variants[variant] || variants.primary} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
}

export default Button;
